import { render } from "./MSTodoPanel.vue?vue&type=template&id=b51e2672&scoped=true&ts=true"
import script from "./MSTodoPanel.vue?vue&type=script&lang=ts"
export * from "./MSTodoPanel.vue?vue&type=script&lang=ts"

import "./MSTodoPanel.vue?vue&type=style&index=0&id=b51e2672&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b51e2672"]])

export default __exports__